module.exports = __webpack_public_path__ + "static/media/HomeStoryLogo7.1081646b.png";